import { call } from 'redux-saga/effects';
import { signalingQuestionDeleted } from 'features/qa/actions';
import { cleanupQANotificationsSaga } from './cleanupQANotificationsSaga';

export function* onQuestionDeletedSaga(action: ReturnType<typeof signalingQuestionDeleted>) {
  yield call(cleanupQANotificationsSaga, action.payload.id);
}
